import React from 'react'

import { pxToRem } from '@/shared/styles/themes'
import { faXmarkLarge } from '@fortawesome/pro-regular-svg-icons/faXmarkLarge'
import { Grid, styled } from '@mui/material'

import { Icon } from '../../Icon/Icon'
import { StyledLightboxButton } from './StyledLightBox'

export type ImageLightboxHeaderProps = {
  onClose: () => void
}

const StyledCloseIcon = styled(Icon)`
  color: ${props => props.theme.palette.text.primary};
  width: ${pxToRem(16)};
  height: ${pxToRem(16)};

  ${props => props.theme.breakpoints.up('sm')} {
    width: ${pxToRem(26)};
    height: ${pxToRem(26)};
  }
`

const StyledHeader = styled(Grid)`
  position: absolute;
`

export const ImageLightboxHeader: React.FC<ImageLightboxHeaderProps> = ({ onClose, ...props }) => (
  <StyledHeader container justifyContent="space-between" {...props}>
    <Grid item />
    <Grid item>
      <StyledLightboxButton
        $isLeft
        disableRipple
        onClick={onClose}
      >
        <StyledCloseIcon icon={faXmarkLarge} />
      </StyledLightboxButton>
    </Grid>
  </StyledHeader>
)
